import React, { useState,useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { styled } from '@mui/system';
import img1a from '../images/g1-a.jpg';
import img1b from '../images/g1-b.jpg';
import img1c from '../images/g1-c.jpg';


import img3a from '../images/g3-a.jpg';
import img3b from '../images/g3-b.jpg';
import img3c from '../images/g3-c.jpg';

import img4a from '../images/g4-a.jpg';
import img4b from '../images/g4-b.jpg';
import img4c from '../images/g4-c.jpg';



import img5a from '../images/g5-a.jpg';
import img5b from '../images/g5-b.jpg';
import img5c from '../images/g5-c.jpg';
import img5d from '../images/g5-d.jpg';
import img5e from '../images/g5-e.jpg';

import img6a from '../images/g6-a.jpg';
import img6b from '../images/g6-b.jpg';
import img6c from '../images/g6-c.jpg';
import img6d from '../images/g6-d.jpg';
import img6e from '../images/g6-e.jpg';


import img7a from '../images/g7-a.jpg';
import img7b from '../images/g7-b.jpg';
import img7c from '../images/g7-c.jpg';


import img8a from '../images/g8-a.jpg';
import img8b from '../images/g8-b.jpg';
import img8c from '../images/g8-c.jpg';
import img8d from '../images/g8-d.jpg';

import img9a from '../images/g9-a.jpg';
import img9b from '../images/g9-b.jpg';
import img9c from '../images/g9-c.jpg';
import img9d from '../images/g9-d.jpg';

import img10a from '../images/g10-a.jpg';
import img10b from '../images/g10-b.jpg';
import img10c from '../images/g10-c.jpg';
import img10d from '../images/g10-d.jpg';

import img11a from '../images/g11-a.jpg';
import img11b from '../images/g11-b.jpg';
import img11c from '../images/g11-c.jpg';
import img11d from '../images/g11-d.jpg';

import img12a from '../images/g12-a.jpg';
import img12b from '../images/g12-b.jpg';
import img12c from '../images/g12-c.jpg';
import img12d from '../images/g12-d.jpg';

import img13a from '../images/g13-a.jpg';
import img13b from '../images/g13-b.jpg';
import img13c from '../images/g13-c.jpg';


const imageGroups = {
  0: [img1a, img1b, img1c],
  1: [img10a, img10b, img10c,img10d],
  2: [img6a, img6b, img6c,img6d,img6e],
  3: [img3a, img3b, img3c],
  4: [img12a, img12b, img12c, img12d],

  5: [img5a, img5b, img5c,img5d,img5e],
 
  6: [img7a, img7b, img7c],
  7: [img8a, img8b, img8c,img8d],
  8: [img9a, img9b, img9c,img9d],

  9: [img11a, img11b, img11c,img11d],
  10: [img4a, img4b, img4c],
  11: [img13a, img13b, img13c],
  
};

const DialogForm1 = ({ isOpen, onClose, imageIndex }) => {
  const [loading, setLoading] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [groupImages, setGroupImages] = useState([]);

  useEffect(() => {
    if (isOpen && imageIndex in imageGroups) {
      setLoading(true); // show loader initially
      setGroupImages([]); // clear previous images immediately
      setCurrentIndex(0);

      const loadTimeout = setTimeout(() => {
        setGroupImages(imageGroups[imageIndex]); // load new group
        setLoading(false); // show images after delay
      }, 1000); // 1.5 seconds loading time

      return () => clearTimeout(loadTimeout);
    }
  }, [isOpen, imageIndex]);

  useEffect(() => {
    if (!isOpen || groupImages.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === groupImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 2500); // Auto scroll every 60 seconds

    return () => clearInterval(interval); // Cleanup
  }, [isOpen, groupImages]);

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      style={{ border: 'none', borderRadius: '0px' }}
    >
      {loading ? (
        <DialogContent>
          <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: '400px' }}>
        
            <div className="spinner-border text-success mt-3" role="status" style={{ width: '3rem', height: '3rem' }}></div>
          </div>
        </DialogContent>
      ) : (
        <DialogContent
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            height: '500px',
            padding: 0,
            overflow: 'hidden',
          }}
        >
          <img
            src={groupImages[currentIndex]}
            alt="Construction Gallery"
            style={{ height: '100%', width: '100%', objectFit: 'cover' }}
          />
        </DialogContent>
      )}
    </Dialog>
  );
};


export default DialogForm1;
